import React from 'react';
import { Avatar } from 'antd';
import ABSLink from '../../components/ABSLink';
import commonUtils from '../../utils/commonUtils';
import routeConfig from '../../abs/config/routeConfig';
import './index.less';

export interface IABSAvatarNameProps {
  imageUrl: string | null;
  name: string;
  userId: string;
}

/**
 * 头像+名字组件
 * @author jingao
 */
export default class ABSAvatarName extends React.Component<IABSAvatarNameProps> {

  renderUserContent() {
    const { name } = this.props;
    return <div title={name}>{name}</div>;
  }

  render() {
    const { imageUrl, userId } = this.props;
    return (
      <ABSLink className="abs-avatar-name-card" target="_blank" to={`${routeConfig.expertPreview}?id=${userId}`}>
        <Avatar
          icon="user"
          className={`abs-avatar-name-card-icon-small`}
          size="small"
          shape="circle"
          src={commonUtils.getAvatar(imageUrl)}
        />
        {this.renderUserContent()}
      </ABSLink>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSAvatarName/index.tsx